module.exports = __webpack_public_path__ + "img/doc.8714afd7.png";